import { buildLegend } from "@features/sales-v3/utils/tooltip";

export const REVENUE_ID = "Revenue";
export const REVENUE_COLOR = "#CDD3FF";
export const REVENUE_LEGEND = buildLegend(
  {
    borderColor: REVENUE_COLOR,
    backgroundColor: REVENUE_COLOR,
    borderDash: [],
  },
  true,
);

export const SPEND_ID = "Spend";
export const SPEND_COLOR = "#7081FF";
export const SPEND_LEGEND = buildLegend(
  {
    borderColor: SPEND_COLOR,
    backgroundColor: SPEND_COLOR,
    borderDash: [],
  },
  true,
);
